// check to see if any ids are already in featuredIdsOnPage
export const checkFeaturedPageIds = (selectedPages, featuredIdsOnPage) => {
  let updatedSelectedPages = []
  if(featuredIdsOnPage && featuredIdsOnPage.length > 0) {
    // Need to loop through selectedPages and check that no id matches one in featuredIdsOnPage, then return that new array
    updatedSelectedPages = selectedPages.filter(hotel => !featuredIdsOnPage.includes(hotel._id))
    // get ids from updated selectedPages so we can to array of featuredIdsOnPage
    const updatedSelectedPageIds = selectedPages.map(hotel => hotel._id)
    // Add these ids to featuredIdsOnPage
    // setFeaturedIdsOnPage(featuredIdsOnPage.concat(updatedSelectedPageIds))
    featuredIdsOnPage = (featuredIdsOnPage.concat(updatedSelectedPageIds))
  } else {
    updatedSelectedPages = selectedPages
  }
  return updatedSelectedPages
}